/**
 * ADR 251 (CardVault) — Carritos guardados, en el carrito de la tienda.
 *
 * Todo vive en the-vault.mx/cart: el carrito actual (el de Shopify) y debajo
 * los carritos guardados, apilados como tarjetas. Se ven, se abren, se
 * renombran, se mueven cartas entre ellos y se elige cuál pagar. Mi Bóveda no
 * tiene sección: CardVault solo guarda.
 *
 *   GET    /api/carritos-guardados?revisar=1         la pila, revisada en vivo
 *   POST   /api/carritos-guardados                   crear (vacío o con cartas)
 *   PATCH  /api/carritos-guardados/:id               renombrar
 *   DELETE /api/carritos-guardados/:id               eliminar
 *   POST   /api/carritos-guardados/:id/duplicar
 *   POST   /api/carritos-guardados/:id/lineas        agregar cartas
 *   PATCH  /api/carritos-guardados/:id/lineas/:l     cantidad
 *   DELETE /api/carritos-guardados/:id/lineas/:l     quitar
 *
 * Shopify cobra UN carrito. Pagar un guardado lo pone en uso: el actual se
 * guarda solo como «Carrito del <fecha>» (nada se pierde), se cargan las
 * cartas disponibles del elegido y se va al pago.
 *
 * Al agregar desde el buscador de listas o desde una ficha, si el comprador ya
 * tiene carritos guardados, se le pregunta a cuál van.
 *
 * La identidad viaja en la cookie firmada (`VaultIdentidad.asegurar()`, ADR
 * 216). Sin sesión: el carrito de siempre, con la invitación a iniciar sesión.
 */
(function () {
  'use strict';

  var COPY = {
    actual: 'Carrito actual',
    enUso: 'en uso',
    crearNuevo: 'Crear carrito nuevo',
    noReserva: 'Guardar no aparta las cartas. Alguien más puede comprarlas mientras tanto.',
    sinSesionTitulo: 'Guarda tus carritos y elige cuál pagar',
    sinSesionTexto: 'Con tu cuenta puedes guardar este carrito con nombre, tener varios a la vez y pagar el que quieras. Tu carrito se queda como está.',
    iniciarSesion: 'Iniciar sesión',
    aCualTitulo: '¿A qué carrito van?',
    aCualTexto: 'Elige dónde guardar estas cartas.',
    vacioGuardado: 'Este carrito está vacío. Llénalo desde cualquier carta: al agregarla te preguntamos a qué carrito va.',
    error: 'No se pudo completar. Intenta de nuevo.',
  };
  var NOMBRE_MAX = 40;
  var CLAVE_ELEGIDO = 'vcc-elegido';

  // ---------------------------------------------------------------------
  // Utilidades
  // ---------------------------------------------------------------------

  function origen() { return window.VaultIdentidad && window.VaultIdentidad.origen; }
  function conSesion() { return !!(window.VaultIdentidad && window.VaultIdentidad.usuarioVisible()); }
  function el(tag, clase, texto) {
    var n = document.createElement(tag);
    if (clase) n.className = clase;
    if (texto !== undefined && texto !== null) n.textContent = texto;
    return n;
  }
  function pesos(n) {
    return '$' + Number(n || 0).toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }
  function plural(n, uno, varios) { return n + ' ' + (n === 1 ? uno : varios); }
  /** " con su carta", " con sus 3 cartas" o nada si está vacío: nunca "sus 1 carta". */
  function conSusCartas(n) {
    if (n === 0) return '';
    return n === 1 ? ' con su carta' : ' con sus ' + n + ' cartas';
  }
  function haceCuanto(iso) {
    var min = Math.max(0, (Date.now() - new Date(iso).getTime()) / 60000);
    if (min < 1) return 'justo ahora';
    if (min < 60) return 'hace ' + Math.floor(min) + ' min';
    var h = min / 60; if (h < 24) return Math.floor(h) === 1 ? 'hace 1 hora' : 'hace ' + Math.floor(h) + ' horas';
    var d = h / 24; if (d < 2) return 'ayer'; if (d < 7) return 'hace ' + Math.floor(d) + ' días';
    if (d < 30) return Math.floor(d / 7) === 1 ? 'hace 1 semana' : 'hace ' + Math.floor(d / 7) + ' semanas';
    return Math.floor(d / 30) <= 1 ? 'hace 1 mes' : 'hace ' + Math.floor(d / 30) + ' meses';
  }
  function fechaCorta() {
    return new Date().toLocaleDateString('es-MX', { day: 'numeric', month: 'short', timeZone: 'America/Mexico_City' }).replace('.', '');
  }
  function imagenAbsoluta(url) {
    if (!url) return undefined;
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url.indexOf('https://') === 0 ? url : undefined;
  }

  /** Llamada a CardVault con la identidad firmada. Rechaza con el mensaje de la API. */
  function api(metodo, ruta, cuerpo) {
    return window.VaultIdentidad.asegurar().then(function () {
      return fetch(origen() + '/api/carritos-guardados' + ruta, {
        method: metodo,
        credentials: 'include',
        headers: cuerpo ? { 'Content-Type': 'application/json' } : undefined,
        body: cuerpo ? JSON.stringify(cuerpo) : undefined,
      });
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var e = new Error(j.error || COPY.error); e.codigo = j.codigo; e.status = r.status; throw e; }
        if (cambiaCuantos(metodo, ruta)) avisarCambioDeCarritos();
        return j;
      });
    });
  }

  /**
   * ¿Esta llamada cambia cuántos carritos hay? Crear (POST a la raíz), duplicar,
   * combinar (borra el de origen) y borrar un carrito entero. Agregar o quitar
   * líneas no cuenta.
   */
  function cambiaCuantos(metodo, ruta) {
    if (metodo === 'POST') return ruta === '' || /\/(duplicar|combinar)$/.test(ruta);
    if (metodo === 'DELETE') return /^\/[^/]+$/.test(ruta);
    return false;
  }
  /** El menú de cuenta escucha esto para refrescar el contador de Carritos Guardados. */
  function avisarCambioDeCarritos() {
    document.dispatchEvent(new CustomEvent('vault:carritos-guardados-cambiaron'));
  }

  function medir(evento, destino, meta) {
    if (typeof window.vaultEvento === 'function') window.vaultEvento(evento, destino || null, meta || {});
  }

  // ---------------------------------------------------------------------
  // Toast
  // ---------------------------------------------------------------------

  var timerToast;
  function toast(texto, deshacer, enlace) {
    var viejo = document.querySelector('.vcc-toast');
    if (viejo) viejo.remove();
    var t = el('div', 'vcc-toast');
    t.setAttribute('role', 'status');
    t.appendChild(el('span', null, texto));
    if (deshacer) {
      var b = el('button', 'vcc-link', 'Deshacer');
      b.type = 'button';
      b.addEventListener('click', function () { t.remove(); deshacer(); });
      t.appendChild(b);
    }
    if (enlace) {
      var a = el('a', 'vcc-link', enlace.texto);
      a.href = enlace.href;
      t.appendChild(a);
    }
    document.body.appendChild(t);
    clearTimeout(timerToast);
    timerToast = setTimeout(function () { t.remove(); }, deshacer || enlace ? 10000 : 5000);
  }

  // ---------------------------------------------------------------------
  // Modales: un asunto por pantalla
  // ---------------------------------------------------------------------

  var modal = null;
  function cerrarModal() {
    if (!modal) return;
    modal.remove(); modal = null;
    document.removeEventListener('keydown', alEscape);
  }
  function alEscape(e) { if (e.key === 'Escape' && modal && modal._alCancelar) modal._alCancelar(); }
  function marco(titulo, texto, alCancelar) {
    cerrarModal();
    modal = el('div', 'vcg');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'vcg-titulo');
    modal._alCancelar = function () { cerrarModal(); if (alCancelar) alCancelar(); };
    var fondo = el('div', 'vcg__fondo');
    fondo.addEventListener('click', modal._alCancelar);
    var caja = el('div', 'vcg__caja');
    var cabeza = el('div', 'vcg__cabeza');
    var h = el('h2', 'vcg__titulo', titulo); h.id = 'vcg-titulo';
    var x = el('button', 'vcg__x', '×'); x.type = 'button'; x.setAttribute('aria-label', 'Cerrar');
    x.addEventListener('click', modal._alCancelar);
    cabeza.appendChild(h); cabeza.appendChild(x);
    caja.appendChild(cabeza);
    if (texto) caja.appendChild(el('p', 'vcg__texto vcg__texto--sutil', texto));
    modal.appendChild(fondo); modal.appendChild(caja);
    document.body.appendChild(modal);
    document.addEventListener('keydown', alEscape);
    return caja;
  }
  /** Alerta azul de información, con el ícono `info` de lucide (mismos trazos que la app). */
  function alertaInfo(texto) {
    var a = el('div', 'vcc-alerta vcc-alerta--info');
    a.setAttribute('role', 'note');
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('fill', 'none'); svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2'); svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('class', 'vcc-alerta__icono');
    svg.innerHTML = '<circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>';
    a.appendChild(svg);
    a.appendChild(el('span', null, texto));
    return a;
  }

  function boton(texto, variante, accion) {
    var b = el('button', 'vcg__btn vcg__btn--' + variante, texto);
    b.type = 'button';
    if (accion) b.addEventListener('click', accion);
    return b;
  }

  /** Pide un nombre. `alGuardar(nombre)` corre con el modal abierto; si falla, el error se queda ahí. */
  function pedirNombre(titulo, texto, valor, etiquetaOk, alGuardar) {
    return new Promise(function (resolver) {
      var caja = marco(titulo, texto, function () { resolver(null); });
      var form = el('form', 'vcg__form');
      var input = el('input', 'vcg__input');
      input.type = 'text'; input.maxLength = NOMBRE_MAX; input.value = valor || '';
      input.setAttribute('aria-label', 'Nombre del carrito');
      var error = el('p', 'vcg__error'); error.setAttribute('role', 'alert'); error.hidden = true;
      var pie = el('div', 'vcg__pie');
      pie.appendChild(boton('Cancelar', 'secundario', function () { cerrarModal(); resolver(null); }));
      var ok = el('button', 'vcg__btn vcg__btn--primario', etiquetaOk || 'Guardar'); ok.type = 'submit';
      pie.appendChild(ok);
      form.appendChild(input);
      form.appendChild(alertaInfo(COPY.noReserva));
      form.appendChild(error);
      form.appendChild(pie);
      caja.appendChild(form);
      input.focus(); input.select();
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var nombre = input.value.replace(/\s+/g, ' ').trim();
        if (!nombre) { input.focus(); return; }
        if (!alGuardar) { cerrarModal(); return resolver(nombre); }
        ok.disabled = true; ok.textContent = 'Guardando…'; error.hidden = true;
        alGuardar(nombre).then(function (r) { cerrarModal(); resolver(r === undefined ? nombre : r); })
          .catch(function (err) {
            error.textContent = (err && err.message) || COPY.error; error.hidden = false;
            ok.disabled = false; ok.textContent = etiquetaOk || 'Guardar';
          });
      });
    });
  }

  /**
   * "¿A qué carrito van?" Resuelve { tipo: 'actual' } | { tipo: 'guardado', carrito }
   * | { tipo: 'nuevo', nombre } | null (cancelar).
   */
  function elegirCarrito(carritos, nombrePorDefecto, piezas) {
    return new Promise(function (resolver) {
      var texto = (piezas ? plural(piezas, 'carta', 'cartas') + ' · ' : '') + COPY.aCualTexto;
      var caja = marco(COPY.aCualTitulo, texto, function () { resolver(null); });
      var lista = el('div', 'vcc-opciones');
      function opcion(titulo, detalle, valor, principal) {
        var b = el('button', 'vcc-opcion' + (principal ? ' vcc-opcion--principal' : ''));
        b.type = 'button';
        b.appendChild(el('b', null, titulo));
        if (detalle) b.appendChild(el('small', null, detalle));
        b.addEventListener('click', function () { cerrarModal(); resolver(valor); });
        lista.appendChild(b);
      }
      opcion(COPY.actual, 'Lo que vas a pagar ahora', { tipo: 'actual' }, true);
      carritos.forEach(function (c) {
        opcion(c.nombre, plural(c.lineas, 'carta', 'cartas') + ' · guardado ' + haceCuanto(c.created_at), { tipo: 'guardado', carrito: c });
      });
      var nuevo = el('button', 'vcc-opcion vcc-opcion--nuevo', '+ ' + COPY.crearNuevo);
      nuevo.type = 'button';
      nuevo.addEventListener('click', function () {
        pedirNombre(COPY.crearNuevo, null, nombrePorDefecto || '', 'Crear y agregar').then(function (n) {
          resolver(n ? { tipo: 'nuevo', nombre: n } : null);
        });
      });
      lista.appendChild(nuevo);
      caja.appendChild(lista);
      lista.querySelector('button').focus();
    });
  }

  /** Carritos guardados (ligero, sin revisar), para el selector de destino. */
  var cacheCarritos = null;
  function misCarritos() {
    if (!conSesion()) return Promise.resolve([]);
    if (cacheCarritos) return cacheCarritos;
    cacheCarritos = api('GET', '').then(function (j) { return j.carritos || []; }).catch(function () { cacheCarritos = null; return []; });
    return cacheCarritos;
  }

  /**
   * Para "Agregar" en el buscador y en la ficha. Resuelve 'actual' cuando las
   * cartas deben ir al carrito de Shopify como siempre; 'hecho' cuando ya se
   * guardaron en otro carrito; null si canceló.
   */
  function elegirDestino(lineas, origenDeAlta, nombrePorDefecto) {
    return misCarritos().then(function (carritos) {
      if (!carritos.length) return 'actual';
      var piezas = lineas.reduce(function (s, l) { return s + (l.cantidad || 1); }, 0);
      return elegirCarrito(carritos, nombrePorDefecto, piezas).then(function (r) {
        if (!r) return null;
        if (r.tipo === 'actual') return 'actual';
        var hacer = r.tipo === 'guardado'
          ? api('POST', '/' + encodeURIComponent(r.carrito.id) + '/lineas', { lineas: lineas }).then(function () { return r.carrito; })
          : api('POST', '', { nombre: r.nombre, origen: origenDeAlta, lineas: lineas }).then(function (j) { return j.carrito; });
        return hacer.then(function (c) {
          cacheCarritos = null;
          medir('saved_cart_added', origenDeAlta, { lineas: lineas.length });
          toast(plural(piezas, 'carta guardada', 'cartas guardadas') + ' en «' + c.nombre + '»', null, { texto: 'Ver en tu carrito', href: '/cart?carrito=' + encodeURIComponent(c.id) });
          return 'hecho';
        }).catch(function (err) { toast((err && err.message) || COPY.error); return null; });
      });
    });
  }

  /** "Guardar carrito" desde el buscador: guarda y aterriza en /cart con el carrito abierto. */
  function guardarLista(lineas, nombrePorDefecto) {
    if (!conSesion()) return pantallaSinSesion();
    if (!lineas.length) return toast('Elige al menos una carta disponible.');
    pedirNombre('Guardar carrito', 'Lo encuentras en tu carrito, debajo del actual. Los precios se revisan cada vez que lo abres.', nombrePorDefecto, 'Guardar', function (nombre) {
      return api('POST', '', { nombre: nombre, origen: 'lista', lineas: lineas }).then(function (j) {
        medir('saved_cart_created', 'lista', { lineas: lineas.length });
        window.location.href = '/cart?guardado=' + encodeURIComponent(j.carrito.id);
      });
    });
  }

  function pantallaSinSesion() {
    var caja = marco(COPY.sinSesionTitulo, COPY.sinSesionTexto);
    var pie = el('div', 'vcg__pie');
    pie.appendChild(boton('Cancelar', 'secundario', cerrarModal));
    var entrar = el('a', 'vcg__btn vcg__btn--primario', COPY.iniciarSesion);
    entrar.href = origen() + '/login';
    pie.appendChild(entrar);
    caja.appendChild(pie);
    entrar.focus();
  }

  // ---------------------------------------------------------------------
  // La pila de /cart
  // ---------------------------------------------------------------------

  var P = { carritos: [], abiertos: {}, elegido: 'actual', menu: null, confirmar: null, cargando: true, resaltado: null };
  try { P.elegido = sessionStorage.getItem(CLAVE_ELEGIDO) || 'actual'; } catch (e) { /* sin storage */ }

  function lineasDelActual() {
    var datos = document.getElementById('vcc-lineas-actual');
    try { return JSON.parse((datos && datos.textContent) || '[]'); } catch (e) { return []; }
  }
  /** Subastas y ofertas ganadas que ya están en el carrito: se cobran con lo que pagues. */
  function temporalesDelActual() {
    var datos = document.getElementById('vcc-temporales-actual');
    try { return JSON.parse((datos && datos.textContent) || '[]'); } catch (e) { return []; }
  }
  /** El carrito actual no tiene nada que cobrar (ni cartas ni subastas u ofertas ganadas). */
  function actualVacio() {
    // Sin el dato (otra página, Dawn a medio pintar) no se sabe: no se bloquea nada.
    if (!document.getElementById('vcc-lineas-actual')) return false;
    return lineasDelActual().length === 0 && temporalesDelActual().length === 0;
  }
  /** El saldo que ya está aplicado al carrito (vault-saldo-carrito.js lo pinta en "Usas $X"). */
  function saldoAplicado() {
    var usando = document.querySelector('#vault-resumen [data-vs="usando"], #vcc-paga [data-vs="usando"]');
    var usa = document.querySelector('#vault-resumen [data-vs="usa"], #vcc-paga [data-vs="usa"]');
    if (!usando || usando.hidden || !usa) return 0;
    var n = Number(String(usa.textContent).replace(/[^0-9.]/g, ''));
    return isFinite(n) ? n : 0;
  }

  function totalActual() {
    var r = document.getElementById('vault-resumen');
    return r ? Number(r.getAttribute('data-total') || 0) / 100 : 0;
  }
  function carritoElegido() {
    for (var i = 0; i < P.carritos.length; i++) if (P.carritos[i].id === P.elegido) return P.carritos[i];
    return null;
  }
  function cambios(c) {
    var k = { bajaron: 0, subieron: 0, agotadas: 0, menos: 0 };
    c.lineas.forEach(function (l) {
      if (l.situacion === 'agotada') { k.agotadas++; return; }
      if (l.situacion === 'disponible' && l.cantidadMovible < l.cantidad) k.menos++;
      if (l.precioAnterior !== null && l.precioActual !== null) { if (l.precioActual < l.precioAnterior) k.bajaron++; else k.subieron++; }
    });
    return k;
  }
  function chipsDeCambios(c) {
    var k = cambios(c), f = document.createDocumentFragment();
    if (k.bajaron) f.appendChild(el('span', 'vcc-chip vcc-chip--ok', '▼ ' + k.bajaron + (k.bajaron === 1 ? ' bajó' : ' bajaron')));
    if (k.subieron) f.appendChild(el('span', 'vcc-chip vcc-chip--warn', '▲ ' + k.subieron + (k.subieron === 1 ? ' subió' : ' subieron')));
    if (k.agotadas) f.appendChild(el('span', 'vcc-chip vcc-chip--bad', k.agotadas + (k.agotadas === 1 ? ' ya no está disponible' : ' ya no están disponibles')));
    if (k.menos) f.appendChild(el('span', 'vcc-chip vcc-chip--warn', k.menos + ' con menos piezas'));
    if (!f.childNodes.length && c.lineas.length) f.appendChild(el('span', 'vcc-chip', 'sin cambios'));
    return f;
  }
  function apiladas(imagenes) {
    var tres = imagenes.slice(0, 3);
    var c = el('div', 'vcc-apiladas');
    c.style.width = (32 + Math.max(0, tres.length - 1) * 11) + 'px';
    if (!tres.length) c.appendChild(el('div', 'vcc-hueco'));
    tres.forEach(function (src, i) {
      var img = el('img'); img.src = src; img.alt = ''; img.loading = 'lazy';
      img.style.left = (i * 11) + 'px'; img.style.zIndex = String(3 - i);
      c.appendChild(img);
    });
    return c;
  }
  function radio(id, nombre) {
    var r = el('button', 'vcc-radio');
    r.type = 'button';
    r.setAttribute('role', 'radio');
    r.setAttribute('aria-checked', String(P.elegido === id));
    r.setAttribute('aria-label', 'Pagar ' + nombre);
    r.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); elegir(id); });
    return r;
  }
  function elegir(id) {
    P.elegido = id;
    try { sessionStorage.setItem(CLAVE_ELEGIDO, id); } catch (e) { /* sin storage */ }
    if (id !== 'actual') P.abiertos[id] = true;
    pintar();
  }

  /** Cabecera del carrito actual (el de Shopify), arriba de las filas de Dawn. */
  function pintarActual() {
    var raiz = document.querySelector('cart-items');
    var items = document.getElementById('main-cart-items');
    var pila = document.getElementById('vault-carritos');
    if (!raiz || !pila || !conSesion()) return;
    raiz.classList.add('vcc-con-pila');
    var vacio = raiz.classList.contains('is-empty');
    var lineas = lineasDelActual();
    var cab = document.getElementById('vcc-cab-actual');
    if (!cab) {
      cab = el('div', 'vcc-cab vcc-cab--actual');
      cab.id = 'vcc-cab-actual';
      // Toda la cabecera elige el carrito actual, no solo el círculo: el
      // actual no se pliega, así que tocarla no tiene otro significado.
      cab.addEventListener('click', function (e) { e.preventDefault(); if (P.elegido !== 'actual') elegir('actual'); });
    }
    // Con cartas, la cabecera encabeza la tarjeta de Dawn; vacío, va sola arriba de la pila.
    var padre = !vacio && items ? items : pila.parentNode;
    var antes = !vacio && items ? items.firstChild : pila;
    if (cab.parentNode !== padre) padre.insertBefore(cab, antes);
    if (items) items.querySelectorAll('tr.cart-item').forEach(ponerMoverEnFila);
    ponerGuardarEnActual(items, lineas.length > 0 && !vacio);
    // Solo se repinta si algo cambió: repintar de más reemplaza el círculo
    // entre el mousedown y el mouseup, y el clic se pierde.
    var firma = [lineas.length, totalActual(), P.elegido, vacio, lineas.map(function (l) { return l.variantId + 'x' + l.cantidad; }).join(',')].join('|');
    if (cab.dataset.firma === firma) return;
    cab.dataset.firma = firma;
    cab.innerHTML = '';
    cab.appendChild(radio('actual', COPY.actual));
    cab.appendChild(apiladas(lineas.map(function (l) { return l.imagen; }).filter(Boolean)));
    var t = el('div', 'vcc-nombre');
    var n = el('div', 'vcc-nombre__n', COPY.actual); n.appendChild(el('span', 'vcc-en-uso', COPY.enUso));
    t.appendChild(n);
    t.appendChild(el('div', 'vcc-meta', lineas.length ? plural(lineas.length, 'carta', 'cartas') + ' · lo que estás armando ahora' : 'Vacío · elige un carrito de abajo para pagarlo'));
    cab.appendChild(t);
    cab.appendChild(el('div', 'vcc-total', pesos(totalActual())));
    cab.classList.toggle('vcc-elegido', P.elegido === 'actual');
    cab.classList.toggle('vcc-cab--sola', vacio);
    if (items) items.classList.toggle('vcc-elegido', P.elegido === 'actual');
  }

  /** "Guardar carrito" vive solo en la tarjeta del carrito actual, al pie, junto a "Vaciar carrito". */
  function ponerGuardarEnActual(items, hayCartas) {
    if (!items) return;
    var pie = document.getElementById('vcc-pie-actual');
    if (!pie) {
      pie = el('div', 'vcc-pie-actual');
      pie.id = 'vcc-pie-actual';
      var b = el('button', 'vcc-guardar-actual', 'Guardar carrito');
      b.type = 'button';
      b.setAttribute('data-vault-guardar-carrito', '');
      pie.appendChild(b);
      var vaciar = document.getElementById('rs-vaciar');
      if (vaciar && vaciar.parentNode === items) items.insertBefore(pie, vaciar); else items.appendChild(pie);
      // "Vaciar carrito" se muda al mismo pie: guardar a la izquierda, vaciar a
      // la derecha. Mover el nodo conserva sus listeners (Dawn lo busca por id).
      if (vaciar) pie.appendChild(vaciar);
    }
    pie.hidden = !hayCartas;
  }

  function ponerMoverEnFila(fila) {
    if (fila.querySelector('.vcc-mover-fila')) return;
    var input = fila.querySelector('[data-quantity-variant-id]');
    if (!input) return;
    // Subastas y ofertas ganadas no se mueven: son únicas y hay que pagarlas.
    var guardables = lineasDelActual().map(function (l) { return String(l.variantId); });
    if (guardables.indexOf(String(input.getAttribute('data-quantity-variant-id'))) === -1) return;
    var celda = fila.querySelector('.cart-item__quantity') || fila.lastElementChild;
    var caja = el('div', 'vcc-mas-caja vcc-mover-fila');
    var b = el('button', 'vcc-mas', 'Mover a…');
    b.type = 'button';
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var abierto = caja.querySelector('.vcc-menu');
      document.querySelectorAll('.vcc-menu').forEach(function (m) { m.remove(); });
      if (abierto) return;
      var menu = el('div', 'vcc-menu');
      menu.setAttribute('role', 'menu');
      menu.appendChild(el('div', 'vcc-menu__rot', 'Mover a…'));
      P.carritos.forEach(function (c) {
        var o = el('button', null, c.nombre); o.type = 'button'; o.setAttribute('role', 'menuitem');
        o.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); moverDesdeActual(fila, c); });
        menu.appendChild(o);
      });
      var nuevo = el('button', null, '+ ' + COPY.crearNuevo); nuevo.type = 'button';
      nuevo.addEventListener('click', function (ev) {
        ev.preventDefault(); ev.stopPropagation();
        pedirNombre(COPY.crearNuevo, null, '', 'Crear y mover').then(function (nombre) {
          if (!nombre) return;
          api('POST', '', { nombre: nombre, origen: 'carrito', lineas: [] }).then(function (j) { moverDesdeActual(fila, j.carrito); })
            .catch(function (err) { toast(err.message); });
        });
      });
      menu.appendChild(nuevo);
      caja.appendChild(menu);
    });
    caja.appendChild(b);
    celda.appendChild(caja);
  }

  function moverDesdeActual(fila, destino) {
    var input = fila.querySelector('[data-quantity-variant-id]');
    var variantId = input.getAttribute('data-quantity-variant-id');
    var cantidad = Number(input.value || 1);
    var indice = Number(input.getAttribute('data-index'));
    var nombre = ((fila.querySelector('.cart-item__name') || {}).textContent || 'La carta').trim();
    var img = fila.querySelector('.cart-item__image');
    api('POST', '/' + encodeURIComponent(destino.id) + '/lineas', {
      lineas: [{ variantId: variantId, cantidad: cantidad, nombre: nombre, imagen: img ? imagenAbsoluta(img.getAttribute('src')) : undefined }],
    }).then(function () {
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: indice, quantity: 0 }) });
    }).then(function () {
      try { sessionStorage.setItem('vcc-toast', nombre + ' pasó a «' + destino.nombre + '»'); sessionStorage.setItem('vcc-abrir', destino.id); } catch (e) { /* */ }
      window.location.reload();
    }).catch(function (err) { toast((err && err.message) || COPY.error); });
  }

  function lineaGuardada(c, l) {
    var agotada = l.situacion === 'agotada';
    var fila = el('div', 'vcc-linea' + (agotada ? ' vcc-linea--agotada' : ''));
    var img = el('img'); img.alt = l.nombre; img.loading = 'lazy';
    if (l.imagen_url) img.src = l.imagen_url;
    fila.appendChild(img);
    var info = el('div', 'vcc-info');
    info.appendChild(el('div', 'vcc-info__t', l.nombre));
    var s = el('div', 'vcc-info__s');
    if (l.set_code) s.appendChild(el('span', null, l.set_code));
    if (l.condicion) s.appendChild(el('span', 'vcc-cond', l.condicion));
    if (agotada) s.appendChild(el('span', 'vcc-chip vcc-chip--bad', 'Ya no disponible'));
    else if (l.precioAnterior !== null && l.precioActual !== null) {
      var bajo = l.precioActual < l.precioAnterior;
      s.appendChild(el('span', 'vcc-chip ' + (bajo ? 'vcc-chip--ok' : 'vcc-chip--warn'), (bajo ? '▼ bajó ' : '▲ subió ') + pesos(Math.abs(l.precioActual - l.precioAnterior))));
    }
    if (!agotada && l.situacion === 'disponible' && l.cantidadMovible < l.cantidad) s.appendChild(el('span', 'vcc-chip vcc-chip--warn', l.cantidadMovible === 1 ? 'Queda 1' : 'Quedan ' + l.cantidadMovible));
    info.appendChild(s);
    fila.appendChild(info);

    var qty = el('div', 'vcc-qty');
    var menos = el('button', null, '−'); menos.type = 'button'; menos.disabled = l.cantidad <= 1 || agotada; menos.setAttribute('aria-label', 'Una menos');
    var mas = el('button', null, '+'); mas.type = 'button'; mas.disabled = agotada || l.cantidad >= 99; mas.setAttribute('aria-label', 'Una más');
    function cambiar(delta) {
      var nueva = Math.max(1, Math.min(99, l.cantidad + delta));
      api('PATCH', '/' + encodeURIComponent(c.id) + '/lineas/' + encodeURIComponent(l.id), { cantidad: nueva }).then(cargar).catch(function (e) { toast(e.message); });
    }
    menos.addEventListener('click', function () { cambiar(-1); });
    mas.addEventListener('click', function () { cambiar(1); });
    qty.appendChild(menos); qty.appendChild(el('span', null, String(l.cantidad))); qty.appendChild(mas);
    fila.appendChild(qty);

    var precio = el('div', 'vcc-precio');
    if (l.precioAnterior !== null && !agotada) precio.appendChild(el('span', 'vcc-precio__antes', pesos(l.precioAnterior * l.cantidadMovible)));
    precio.appendChild(el('span', 'vcc-precio__ahora', agotada ? '—' : pesos((l.precioActual || 0) * l.cantidadMovible)));
    fila.appendChild(precio);

    var caja = el('div', 'vcc-mas-caja');
    var b = el('button', 'vcc-mas vcc-mas--icono', '⋯'); b.type = 'button';
    b.setAttribute('aria-label', 'Más acciones para ' + l.nombre); b.setAttribute('aria-haspopup', 'menu');
    b.addEventListener('click', function (e) { e.stopPropagation(); P.menu = P.menu === l.id ? null : l.id; pintar(); });
    caja.appendChild(b);
    if (P.menu === l.id) {
      var menu = el('div', 'vcc-menu'); menu.setAttribute('role', 'menu');
      menu.appendChild(el('div', 'vcc-menu__rot', 'Mover a…'));
      if (!agotada) {
        var aActual = el('button', null, COPY.actual); aActual.type = 'button';
        aActual.addEventListener('click', function (e) { e.stopPropagation(); moverAlActual(c, l); });
        menu.appendChild(aActual);
      }
      P.carritos.filter(function (o) { return o.id !== c.id; }).forEach(function (o) {
        var bo = el('button', null, o.nombre); bo.type = 'button';
        bo.addEventListener('click', function (e) { e.stopPropagation(); moverEntreGuardados(c, l, o); });
        menu.appendChild(bo);
      });
      menu.appendChild(el('hr'));
      var quitar = el('button', 'vcc-rojo', 'Quitar de «' + c.nombre + '»'); quitar.type = 'button';
      quitar.addEventListener('click', function (e) { e.stopPropagation(); quitarLinea(c, l); });
      menu.appendChild(quitar);
      caja.appendChild(menu);
    }
    fila.appendChild(caja);
    return fila;
  }

  function moverAlActual(c, l) {
    P.menu = null;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(l.shopify_variant_id), quantity: l.cantidadMovible || 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('Esa carta ya no se puede agregar al carrito.'); })
      .then(function () { return api('DELETE', '/' + encodeURIComponent(c.id) + '/lineas/' + encodeURIComponent(l.id)); })
      .then(function () {
        try { sessionStorage.setItem('vcc-toast', l.nombre + ' pasó a tu carrito actual'); } catch (e) { /* */ }
        window.location.reload();
      })
      .catch(function (e) { toast(e.message); pintar(); });
  }
  function moverEntreGuardados(c, l, destino) {
    P.menu = null;
    api('POST', '/' + encodeURIComponent(destino.id) + '/lineas', { lineas: [{ variantId: l.shopify_variant_id, cantidad: l.cantidad, nombre: l.nombre, imagen: l.imagen_url || undefined }] })
      .then(function () { return api('DELETE', '/' + encodeURIComponent(c.id) + '/lineas/' + encodeURIComponent(l.id)); })
      .then(function () { P.abiertos[destino.id] = true; toast(l.nombre + ' pasó a «' + destino.nombre + '»'); return cargar(); })
      .catch(function (e) { toast(e.message); });
  }
  function quitarLinea(c, l) {
    P.menu = null;
    api('DELETE', '/' + encodeURIComponent(c.id) + '/lineas/' + encodeURIComponent(l.id)).then(function () {
      toast('Quitaste ' + l.nombre + ' de «' + c.nombre + '»', function () {
        api('POST', '/' + encodeURIComponent(c.id) + '/lineas', { lineas: [{ variantId: l.shopify_variant_id, cantidad: l.cantidad, nombre: l.nombre, imagen: l.imagen_url || undefined }] }).then(cargar);
      });
      return cargar();
    }).catch(function (e) { toast(e.message); });
  }

  function tarjetaGuardada(c) {
    var abierto = !!P.abiertos[c.id];
    var t = el('section', 'vcc-carrito' + (abierto ? ' vcc-abierto' : '') + (P.elegido === c.id ? ' vcc-elegido' : '') + (P.resaltado === c.id ? ' vcc-resaltado' : ''));
    t.setAttribute('aria-label', c.nombre);
    var cab = el('div', 'vcc-cab');
    cab.tabIndex = 0;
    cab.addEventListener('click', function () { P.abiertos[c.id] = !abierto; P.menu = null; pintar(); });
    cab.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); cab.click(); } });
    cab.appendChild(radio(c.id, c.nombre));
    cab.appendChild(apiladas(c.lineas.map(function (l) { return l.imagen_url; }).filter(Boolean)));
    var n = el('div', 'vcc-nombre');
    n.appendChild(el('div', 'vcc-nombre__n', c.nombre));
    var meta = el('div', 'vcc-meta');
    meta.appendChild(el('span', null, plural(c.lineas.length, 'carta', 'cartas') + ' · guardado ' + haceCuanto(c.created_at)));
    meta.appendChild(chipsDeCambios(c));
    n.appendChild(meta);
    cab.appendChild(n);
    cab.appendChild(el('div', 'vcc-total', pesos(c.resumen.subtotal)));
    var chev = el('span', 'vcc-chev', '⌄'); chev.setAttribute('aria-hidden', 'true');
    cab.appendChild(chev);
    t.appendChild(cab);
    if (!abierto) return t;

    var cuerpo = el('div', 'vcc-cuerpo');
    if (!c.lineas.length) cuerpo.appendChild(el('div', 'vcc-vacio', COPY.vacioGuardado));
    c.lineas.forEach(function (l) { cuerpo.appendChild(lineaGuardada(c, l)); });
    t.appendChild(cuerpo);

    var pie = el('div', 'vcc-pie');
    if (P.confirmar === c.id) {
      pie.appendChild(el('span', 'vcc-pie__pregunta', '¿Eliminar «' + c.nombre + '»' + conSusCartas(c.lineas.length) + '?'));
      pie.appendChild(boton('Cancelar', 'secundario', function () { P.confirmar = null; pintar(); }));
      pie.appendChild(boton('Eliminar', 'peligro', function () {
        api('DELETE', '/' + encodeURIComponent(c.id)).then(function () {
          if (P.elegido === c.id) elegir('actual');
          P.confirmar = null; toast('Eliminaste «' + c.nombre + '»'); return cargar();
        }).catch(function (e) { toast(e.message); });
      }));
    } else {
      var ren = el('button', 'vcc-link', 'Renombrar'); ren.type = 'button';
      ren.addEventListener('click', function () {
        pedirNombre('Renombrar carrito', null, c.nombre, 'Guardar nombre', function (nombre) {
          return api('PATCH', '/' + encodeURIComponent(c.id), { nombre: nombre }).then(function () { return cargar(); });
        });
      });
      var dup = el('button', 'vcc-link', 'Duplicar'); dup.type = 'button';
      dup.addEventListener('click', function () {
        api('POST', '/' + encodeURIComponent(c.id) + '/duplicar').then(function (j) { P.resaltado = j.carrito.id; toast('Creamos «' + j.carrito.nombre + '»'); return cargar(); }).catch(function (e) { toast(e.message); });
      });
      var eli = el('button', 'vcc-link vcc-rojo', 'Eliminar carrito'); eli.type = 'button';
      eli.addEventListener('click', function () { P.confirmar = c.id; pintar(); });
      pie.appendChild(ren); pie.appendChild(dup); pie.appendChild(eli);
      pie.appendChild(el('span', 'vcc-pie__nota', 'Precios de hoy · guardar no aparta cartas'));
    }
    t.appendChild(pie);
    return t;
  }

  /**
   * Muestra de lo que vas a pagar en la barra del teléfono: miniaturas
   * encimadas, hasta 4 y "+N" (un pedido se representa con sus cartas).
   */
  function muestraEnBarra(barra, imagenes) {
    var muestra = barra.querySelector('.vcc-barra-muestra');
    var firma = imagenes.join('|');
    if (muestra && muestra.dataset.firma === firma) return;
    if (!muestra) {
      muestra = el('div', 'vcc-barra-muestra');
      muestra.setAttribute('aria-hidden', 'true');
      barra.insertBefore(muestra, barra.firstChild);
    }
    muestra.dataset.firma = firma;
    muestra.innerHTML = '';
    muestra.hidden = !imagenes.length;
    var cuatro = imagenes.slice(0, 4);
    cuatro.forEach(function (src, i) {
      var img = el('img'); img.src = src; img.alt = ''; img.loading = 'lazy';
      img.style.left = (i * 14) + 'px'; img.style.zIndex = String(10 - i);
      muestra.appendChild(img);
    });
    var ancho = 31 + Math.max(0, cuatro.length - 1) * 14;
    if (imagenes.length > 4) {
      var mas = el('span', 'vcc-barra-muestra__mas', '+' + (imagenes.length - 4));
      mas.style.left = ancho - 8 + 'px';
      muestra.appendChild(mas);
      ancho += 14;
    }
    muestra.style.width = ancho + 'px';
  }

  /** La barra fija de pago del teléfono dice lo mismo que el resumen: el carrito elegido. */
  function pintarBarraMovil(c, piezas) {
    var barra = document.querySelector('.vault-barra-pago');
    if (!barra) return;
    var total = barra.querySelector('.vault-barra-pago__total');
    var cartas = barra.querySelector('.vault-barra-pago__cartas');
    var boton = barra.querySelector('.vault-barra-pago__boton');
    if (!total || !cartas || !boton) return;
    // Las agotadas no se cobran: no van en la muestra.
    var imgsTemporales = temporalesDelActual().map(function (t) { return t.imagen; }).filter(Boolean);
    muestraEnBarra(barra, c
      ? c.lineas.filter(function (l) { return l.situacion !== 'agotada' && l.imagen_url; }).map(function (l) { return l.imagen_url; }).concat(imgsTemporales)
      : lineasDelActual().map(function (l) { return l.imagen; }).filter(Boolean).concat(imgsTemporales));
    // Solo el conteo cambia; el recordatorio del punto (en amarillo) se queda.
    var conteo = cartas.querySelector('.vault-barra-pago__n') || cartas;
    if (!c) {
      if (barra.dataset.vccOriginal) {
        var o = JSON.parse(barra.dataset.vccOriginal);
        total.textContent = o.total; conteo.textContent = o.cartas; boton.textContent = o.boton; boton.disabled = false;
        delete barra.dataset.vccOriginal;
      }
      return;
    }
    if (!barra.dataset.vccOriginal) {
      barra.dataset.vccOriginal = JSON.stringify({ total: total.textContent, cartas: conteo.textContent, boton: boton.textContent });
    }
    var cuentas = cuentaDePago(c);
    total.textContent = pesos(cuentas.total);
    conteo.textContent = plural(piezas + cuentas.temporales.length, 'carta', 'cartas');
    boton.textContent = piezas ? 'Pagar «' + c.nombre + '»' : 'Nada que pagar';
    boton.disabled = !piezas;
  }

  function pintarResumen() {
    var ctas = document.querySelector('.cart__ctas');
    var checkout = document.getElementById('checkout');
    var resumen = document.getElementById('vault-resumen');
    var c = carritoElegido();
    var box = document.getElementById('vcc-paga');
    // Los botones exprés (PayPal, Google Pay, Shop Pay) pagan el carrito de
    // Shopify tal cual: con un guardado elegido se brincarían el intercambio.
    document.body.classList.toggle('vcc-pagando-guardado', !!c);
    if (!c) {
      pintarBarraMovil(null);
      devolverSaldo(box, resumen);
      if (box) box.remove();
      if (resumen) resumen.classList.remove('vcc-oculto');
      if (checkout && checkout.dataset.vccTexto) {
        checkout.textContent = checkout.dataset.vccTexto;
        delete checkout.dataset.vccTexto;
        // Si cart-availability lo bloqueó por agotados, se queda bloqueado.
        checkout.disabled = checkout.dataset.vaultBlocked === '1';
      }
      // Pagar el carrito actual vacío no lleva a nada: el botón se apaga.
      if (checkout && actualVacio()) checkout.disabled = true;
      setTimeout(alinear, 0);
      return;
    }
    if (!ctas || !checkout) return;
    if (!box) { box = el('div', 'vcc-paga'); box.id = 'vcc-paga'; ctas.parentNode.insertBefore(box, ctas); }
    if (resumen) resumen.classList.add('vcc-oculto');
    var firma = [c.id, c.resumen.subtotal, c.lineas.length, lineasDelActual().length, temporalesDelActual().length, saldoAplicado(), checkout.textContent].join('|');
    if (box.dataset.firma === firma && box.parentNode === ctas.parentNode) {
      traerSaldo(box, resumen, box.querySelector('.vcc-paga__total'));
      pintarBarraMovil(c, c.lineas.reduce(function (s2, l) { return s2 + (l.situacion === 'agotada' ? 0 : l.cantidadMovible); }, 0));
      return;
    }
    // Las cuentas leen el saldo del bloque: se calculan antes de apartarlo.
    var cuentas = cuentaDePago(c);
    // El bloque "Usar mi saldo" vive dentro de esta caja: se aparta antes de vaciarla.
    var bloqueSaldo = box.querySelector('[data-vs="bloque"]');
    if (bloqueSaldo) bloqueSaldo.remove();
    box.innerHTML = '';
    box.appendChild(el('h2', 'vcc-paga__h', 'Vas a pagar'));
    var quien = el('div', 'vcc-paga__quien');
    quien.appendChild(apiladas(c.lineas.map(function (l) { return l.imagen_url; }).filter(Boolean)));
    var piezas = c.lineas.reduce(function (s, l) { return s + (l.situacion === 'agotada' ? 0 : l.cantidadMovible); }, 0);
    var q = el('div'); q.appendChild(el('b', null, c.nombre)); q.appendChild(el('small', null, plural(piezas, 'carta', 'cartas')));
    quien.appendChild(q);
    box.appendChild(quien);
    if (cuentas.temporales.length) {
      var t = el('div', 'vcc-paga__linea');
      t.appendChild(el('span', null, cuentas.temporales.length === 1 ? 'Tu ' + etiquetaTemporal(cuentas.temporales[0]) + ' ganada' : 'Tus subastas y ofertas ganadas'));
      t.appendChild(el('span', null, '+' + pesos(cuentas.sumaTemporales)));
      box.appendChild(t);
    }
    // El saldo no lleva renglón aparte: el bloque "Usar mi saldo" ya dice cuánto
    // usas y va justo arriba del total.
    var tot = el('div', 'vcc-paga__total'); tot.appendChild(el('span', null, 'Total a pagar')); tot.appendChild(el('span', null, pesos(cuentas.total)));
    box.appendChild(tot);
    if (bloqueSaldo) box.insertBefore(bloqueSaldo, tot);
    traerSaldo(box, resumen, tot);
    var notas = [];
    if (cuentas.temporales.length) notas.push('Lo que ganaste en subasta u oferta ya está en tu carrito y se paga junto con este pedido.');
    if (c.resumen.agotadas) notas.push(plural(c.resumen.agotadas, 'carta ya no está disponible y no se cobra.', 'cartas ya no están disponibles y no se cobran.'));
    var actual = lineasDelActual();
    if (actual.length) notas.push('Tu carrito actual (' + plural(actual.length, 'carta', 'cartas') + ') se guarda solo como «Carrito del ' + fechaCorta() + '». No se pierde nada.');
    notas.push('El envío, si lo eliges, se calcula al pagar.');
    box.appendChild(el('p', 'vcc-paga__nota', notas.join(' ')));
    if (!checkout.dataset.vccTexto) checkout.dataset.vccTexto = checkout.textContent.trim();
    pintarBarraMovil(c, piezas);
    var etiqueta = piezas ? 'Pagar «' + c.nombre + '»' : 'Nada que pagar';
    if (checkout.textContent !== etiqueta) checkout.textContent = etiqueta;
    checkout.disabled = !piezas;
    box.dataset.firma = [c.id, c.resumen.subtotal, c.lineas.length, lineasDelActual().length, temporalesDelActual().length, saldoAplicado(), checkout.textContent].join('|');
    // Una vez de inmediato y otra cuando la tarjeta recién abierta terminó de acomodarse.
    setTimeout(alinear, 0);
    setTimeout(alinear, 300);
  }

  /**
   * En escritorio, "Vas a pagar" baja hasta la altura del carrito elegido: la
   * columna derecha cuenta lo que pasa con el que tocaste. Solo cuando las
   * dos columnas están lado a lado; en el teléfono el resumen va abajo.
   */
  function alinear() {
    var columna = document.querySelector('.cart__footer');
    var seccionItems = document.querySelector('cart-items');
    if (!columna || !seccionItems) return;
    var ladoALado = columna.getBoundingClientRect().left >= seccionItems.getBoundingClientRect().right - 40;
    var c = carritoElegido();
    var tarjeta = c && document.querySelector('.vcc-carrito.vcc-elegido');
    var caja = document.getElementById('vcc-paga');
    var objetivo = 0;
    // La columna del resumen es sticky: va pegada a la pantalla al hacer
    // scroll, y su posición dependía de qué tan abajo estabas (en los últimos
    // carritos salía corrida). Mientras se alinea con un guardado, se ancla.
    var seccion = columna.closest('.shopify-section');
    if (seccion) seccion.classList.toggle('vcc-anclada', !!(ladoALado && tarjeta && caja));
    if (ladoALado && tarjeta && caja) {
      // La posición natural de la caja, sin el margen que lleva en este
      // instante (a media animación el rect miente).
      var actual = parseFloat(getComputedStyle(columna).marginTop) || 0;
      var natural = caja.getBoundingClientRect().top - actual;
      objetivo = Math.max(0, tarjeta.getBoundingClientRect().top - natural);
    }
    columna.classList.add('vcc-columna');
    // Margen y no transform: el margen empuja lo de abajo; con transform la
    // columna se encimaba sobre el pie de página.
    columna.style.marginTop = objetivo ? Math.round(objetivo) + 'px' : '';
  }
  window.addEventListener('resize', function () { clearTimeout(alinear._t); alinear._t = setTimeout(alinear, 120); });

  function etiquetaTemporal(t) { return t.tipo === 'Auction' ? 'subasta' : 'oferta'; }

  /** Lo que de verdad se cobra al pagar un guardado: sus cartas + temporales − saldo aplicado. */
  function cuentaDePago(c) {
    var temporales = temporalesDelActual();
    var sumaTemporales = temporales.reduce(function (s, t) { return s + (Number(t.precio) || 0); }, 0);
    var bruto = c.resumen.subtotal + sumaTemporales;
    var saldo = saldoAplicado();
    var saldoUsado = Math.min(saldo, bruto);
    return { temporales: temporales, sumaTemporales: sumaTemporales, saldo: saldo, saldoUsado: saldoUsado, total: Math.max(0, bruto - saldoUsado) };
  }

  /**
   * "Usar mi saldo" (vault-saldo-carrito.js) vive en el resumen, que se oculta
   * cuando pagas un guardado. Para que el saldo se pueda usar, el bloque se muda
   * a "Vas a pagar", justo antes del total. Si Dawn volvió a pintar el resumen,
   * trae uno nuevo y ese es el que se muda (el viejo se descarta).
   */
  function traerSaldo(box, resumen, antes) {
    var nuevo = resumen && resumen.querySelector('[data-vs="bloque"]');
    if (!nuevo || !antes) return;
    var viejo = box.querySelector('[data-vs="bloque"]');
    if (viejo) viejo.remove();
    box.insertBefore(nuevo, antes);
  }
  /** De regreso al carrito actual: el bloque vuelve a su lugar en el resumen. */
  function devolverSaldo(box, resumen) {
    var bloque = box && box.querySelector('[data-vs="bloque"]');
    if (!bloque || !resumen) return;
    if (resumen.querySelector('[data-vs="bloque"]')) { bloque.remove(); return; }
    var hr = resumen.querySelector('.rs__hr');
    resumen.insertBefore(bloque, hr || null);
  }

  /** Pagar un guardado: el actual se guarda, el elegido entra a Shopify, y al pago. */
  function pagarGuardado(c) {
    var checkout = document.getElementById('checkout');
    if (checkout) { checkout.disabled = true; checkout.textContent = 'Preparando tu pago…'; }
    var actual = lineasDelActual();
    var guardarActual = actual.length
      ? api('POST', '', { nombre: 'Carrito del ' + fechaCorta(), origen: 'carrito', lineas: actual })
      : Promise.resolve(null);
    guardarActual.then(function () {
      if (!actual.length) return null;
      var updates = {};
      actual.forEach(function (l) { updates[l.variantId] = 0; });
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
    }).then(function () {
      var items = c.lineas.filter(function (l) { return l.situacion !== 'agotada' && l.cantidadMovible > 0; })
        .map(function (l) { return { id: Number(l.shopify_variant_id), quantity: l.cantidadMovible }; });
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('Algunas cartas de «' + c.nombre + '» ya no se pueden comprar. Revisa el carrito.'); });
    }).then(function () {
      return api('DELETE', '/' + encodeURIComponent(c.id));
    }).then(function () {
      medir('saved_cart_reactivated', 'carrito', { lineas: c.lineas.length });
      try { sessionStorage.setItem(CLAVE_ELEGIDO, 'actual'); } catch (e) { /* */ }
      // El saldo que eligió para este carrito se pega ahora, contra las cartas
      // que ya entraron a Shopify (ADR 241). Si falla, regresa al carrito —ya con
      // estas cartas— en vez de cobrar sin el saldo que pidió.
      var saldo = window.VaultSaldoCarrito;
      return (saldo && saldo.alPagarGuardado ? saldo.alPagarGuardado() : Promise.resolve(true));
    }).then(function (saldoOk) {
      if (!saldoOk) throw new Error('Tus cartas ya están en el carrito, pero no pudimos usar tu saldo. Vuelve a activarlo y paga.');
      window.location.href = '/checkout';
    }).catch(function (e) {
      try { sessionStorage.setItem('vcc-toast', e.message); sessionStorage.setItem(CLAVE_ELEGIDO, 'actual'); } catch (x) { /* */ }
      window.location.reload();
    });
  }

  function pintar() {
    var raiz = document.getElementById('vault-carritos');
    if (!raiz) return;
    raiz.innerHTML = '';
    if (!conSesion()) {
      var s = el('div', 'vcc-sin-sesion');
      s.appendChild(el('b', null, COPY.sinSesionTitulo));
      s.appendChild(el('p', null, COPY.sinSesionTexto));
      var a = el('a', 'vcg__btn vcg__btn--primario', COPY.iniciarSesion); a.href = origen() + '/login';
      s.appendChild(a);
      raiz.appendChild(s);
      return;
    }
    pintarActual();
    // El saldo escucha esto: cambió cuál carrito se paga (o ya cargaron los guardados).
    document.dispatchEvent(new CustomEvent('vault:carrito-elegido'));
    if (P.cargando) { raiz.appendChild(el('div', 'vcc-cargando', 'Cargando tus carritos guardados…')); return; }
    P.carritos.forEach(function (c) { raiz.appendChild(tarjetaGuardada(c)); });
    var nuevo = el('button', 'vcc-nuevo', '+ ' + COPY.crearNuevo); nuevo.type = 'button';
    nuevo.addEventListener('click', function () {
      pedirNombre(COPY.crearNuevo, 'Ponle nombre y llénalo después: cada vez que agregues cartas te preguntamos a qué carrito van.', '', 'Crear', function (nombre) {
        return api('POST', '', { nombre: nombre, origen: 'carrito', lineas: [] }).then(function (j) {
          medir('saved_cart_created', 'carrito', { lineas: 0 });
          P.abiertos[j.carrito.id] = true; P.resaltado = j.carrito.id; toast('Creaste «' + j.carrito.nombre + '»');
          return cargar();
        });
      });
    });
    raiz.appendChild(nuevo);
    pintarResumen();
  }

  function cargar() {
    return api('GET', '?revisar=1').then(function (j) {
      P.carritos = j.carritos || []; P.cargando = false;
      cacheCarritos = null;
      if (P.elegido !== 'actual' && !carritoElegido()) P.elegido = 'actual';
      pintar();
    }).catch(function () { P.carritos = []; P.cargando = false; pintar(); });
  }

  function iniciarPila() {
    if (!document.getElementById('vault-carritos')) return;
    var params = new URLSearchParams(window.location.search);
    var abrir = params.get('guardado') || params.get('carrito');
    try { abrir = abrir || sessionStorage.getItem('vcc-abrir'); sessionStorage.removeItem('vcc-abrir'); } catch (e) { /* */ }
    if (abrir) { P.abiertos[abrir] = true; P.resaltado = abrir; }
    if (params.get('guardado')) toast('Carrito guardado ✓');
    try { var t = sessionStorage.getItem('vcc-toast'); if (t) { toast(t); sessionStorage.removeItem('vcc-toast'); } } catch (e) { /* */ }
    pintar();
    if (conSesion()) cargar();

    // Dawn reemplaza el contenido del carrito y del resumen en cada cambio de
    // cantidad: se vuelve a pintar la cabecera y la elección de pago.
    var obs = new MutationObserver(function (cambiosDom) {
      // Lo que pinta este módulo no cuenta: sin esto, pintar el resumen
      // disparaba al observador, que volvía a pintar, en ciclo.
      var deDawn = cambiosDom.some(function (m) {
        var n = m.target.nodeType === 1 ? m.target : m.target.parentElement;
        return !(n && n.closest && n.closest('#vcc-paga, #vcc-cab-actual, #vcc-pie-actual, .vcc-mover-fila, #checkout'));
      });
      if (!deDawn) return;
      clearTimeout(obs._t);
      obs._t = setTimeout(function () { if (conSesion()) { pintarActual(); pintarResumen(); } }, 60);
    });
    document.querySelectorAll('#main-cart-items .js-contents, .cart__footer').forEach(function (n) {
      obs.observe(n, { childList: true, subtree: true });
    });
    // La barra del teléfono la crea vault-carrito.js, a veces después de este
    // módulo: cuando aparece, se le pone la muestra y el carrito elegido.
    new MutationObserver(function (cambiosBody) {
      var llego = cambiosBody.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) { return n.classList && n.classList.contains('vault-barra-pago'); });
      });
      if (llego && conSesion()) pintarResumen();
    }).observe(document.body, { childList: true });
    // Sin sesión también se ve la muestra del carrito actual.
    if (!conSesion()) setTimeout(function () { var b = document.querySelector('.vault-barra-pago'); if (b) muestraEnBarra(b, lineasDelActual().map(function (l) { return l.imagen; }).filter(Boolean)); }, 500);

    // "Pagar «X»": si se eligió un guardado, el botón de pago hace el intercambio.
    document.addEventListener('click', function (e) {
      // También la barra fija del teléfono (vault-carrito.js): su botón envía
      // el mismo formulario sin pasar por #checkout, y se brincaba el intercambio.
      var b = e.target.closest && e.target.closest('#checkout, [data-vault-pagar]');
      if (!b) return;
      var c = carritoElegido();
      if (!c) {
        // Por si algo volvió a habilitar el botón: el actual vacío no pasa al pago.
        if (!actualVacio()) return;
        e.preventDefault(); e.stopImmediatePropagation();
        toast(P.carritos.length ? 'Tu carrito actual está vacío. Elige un carrito guardado para pagarlo.' : 'Tu carrito está vacío.');
        return;
      }
      e.preventDefault(); e.stopImmediatePropagation();
      pagarGuardado(c);
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.vcc-mas-caja')) return;
      var habia = P.menu || document.querySelector('.vcc-mover-fila .vcc-menu');
      if (!habia) return;
      P.menu = null;
      document.querySelectorAll('.vcc-mover-fila .vcc-menu').forEach(function (m) { m.remove(); });
      pintar();
    });
  }

  // ---------------------------------------------------------------------
  // "Guardar carrito" (botón bajo el de pagar): el actual pasa a la pila.
  // ---------------------------------------------------------------------

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-vault-guardar-carrito]');
    if (!b) return;
    e.preventDefault();
    if (!conSesion()) return pantallaSinSesion();
    var lineas = lineasDelActual();
    if (!lineas.length) return toast('Tu carrito actual no tiene cartas que guardar.');
    var porDefecto = (lineas[0].nombre || 'Mi carrito').replace(/\s*\[.*\]\s*$/, '');
    if (lineas.length > 1) porDefecto = porDefecto.slice(0, NOMBRE_MAX - 10) + ' y ' + (lineas.length - 1) + ' más';
    pedirNombre('Guardar carrito', 'Queda debajo de tu carrito actual, y el actual se vacía para que sigas comprando.', porDefecto, 'Guardar', function (nombre) {
      return api('POST', '', { nombre: nombre, origen: 'carrito', lineas: lineas }).then(function (j) {
        var updates = {};
        lineas.forEach(function (l) { updates[l.variantId] = 0; });
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) }).then(function () {
          medir('saved_cart_created', 'carrito', { lineas: lineas.length });
          window.location.href = '/cart?guardado=' + encodeURIComponent(j.carrito.id);
        });
      });
    });
  });

  // ---------------------------------------------------------------------
  // Ficha de producto: "Agregar al carrito" pregunta a qué carrito va.
  // ---------------------------------------------------------------------

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (form.dataset.vccPasa === '1') { delete form.dataset.vccPasa; return; }
    if (!conSesion()) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var qty = Number((form.querySelector('[name="quantity"]') || {}).value || 1);
    var titulo = ((document.querySelector('.product__title h1') || document.querySelector('.product__title') || {}).textContent || '').trim();
    var lineas = [{ variantId: String(idInput.value), cantidad: qty, nombre: titulo || undefined }];
    elegirDestino(lineas, 'ficha', titulo.replace(/\s*\[.*\]\s*$/, '')).then(function (r) {
      if (r !== 'actual') return;
      form.dataset.vccPasa = '1';
      var boton = form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
      if (form.requestSubmit) form.requestSubmit(boton || undefined); else form.submit();
    });
  }, true);

  /**
   * Lo que se cobraría si pagas el guardado elegido (sus cartas + subastas u
   * ofertas ya en el carrito), o null si vas a pagar el carrito actual. Lo lee
   * vault-saldo-carrito.js: con un guardado elegido, el saldo se calcula contra
   * este total y se pega al carrito de Shopify hasta el intercambio.
   */
  function cobroElegido() {
    var c = carritoElegido();
    if (!c) return null;
    var temporales = temporalesDelActual().reduce(function (s, t) { return s + (Number(t.precio) || 0); }, 0);
    return { total: c.resumen.subtotal + temporales, nombre: c.nombre };
  }

  // El saldo se repintó (prendió, cambió el monto): "Vas a pagar" recalcula.
  // Hace falta el aviso porque el observador ignora lo que pasa dentro de #vcc-paga.
  document.addEventListener('vault:saldo-pintado', function () { if (conSesion()) pintarResumen(); });

  window.VaultCarritoGuardado = {
    elegirDestino: elegirDestino,
    guardarLista: guardarLista,
    cobroElegido: cobroElegido,
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarPila);
  else iniciarPila();
})();
